export default __webpack_public_path__ + "static/media/know-msk.03cf74d1.png";